const initialState = {
  resourcesAllLoaded: false,
  isLoadingResources: false,
  lastRefreshedAt: null,

  // Resources that have not yet been refreshed
  staleResources: {},

  attendanceTypes: [],
  attendanceTypesById: {},
  attendanceReasons: [],
  attendanceReasonsById: {},
  timeOffTypes: [],
  timeOffTypesById: {},
  requestStatus: [],
  requestStatusById: {},
  vacationTypesById: {},

  departments: [],
  departmentsById: {},
  departmentsIds: [],

  hiringData: [],
  hiringDataById: {},
  hiringDataIds: [],

  holidays: [],
  holidaysById: {},
  holidaysIds: [],

  wagePremiums: [],
  wagePremiumsById: {},
  wagePremiumsIds: [],

  permissions: [],
  permissionsById: {},
  permissionsIds: [],

  positions: [],
  positionsIds: [],
  positionsById: {},

  punchRules: [],
  punchRulesById: {},
  punchRulesIds: [],

  projects: [],
  projectsById: {},
  projectsIds: [],

  projectOwners: [],
  projectOwnersById: {},
  projectOwnersIds: [],

  scheduleTypes: [],
  scheduleTypesById: {},
  scheduleTypesIds: [],
  // Remove schedule types that are used only for filtering.
  nonFilterScheduleTypes: [],

  scheduleTemplates: [],
  scheduleTemplatesById: {},
  scheduleTemplatesIds: [],

  tags: [],
  tagsById: {},
  tagsIds: [],

  teams: [],
  teamsById: {},
  teamsIds: [],

  users: [],
  usersById: {},
  usersIds: [],

  userTemplates: [],
  userTemplatesById: {},
  userTemplatesIds: [],

  contactTemplates: [],

  // CONFIGS
  configs: [],
  configsById: {},
  configsIds: [],
  filters: [],
  filtersById: {},
  filtersIds: [],
  procedures: [],
  proceduresById: {},
  proceduresIds: [],
  sorts: [],
  sortsById: {},
  sortsIds: []
}

const resources = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CONFIGS':
      return { ...state, configsById: action.configsById, configsIds: action.configsIds, configs: action.configs }

    case 'SET_CONTACT_TEMPLATES':
      return {
        ...state,
        contactTemplatesById: action.contactTemplatesById,
        contactTemplatesIds: action.contactTemplatesIds,
        contactTemplates: action.contactTemplates
      }

    case 'SET_DEPARTMENTS':
      return { ...state, departmentsIds: action.departmentsIds, departmentsById: action.departmentsById, departments: action.departments }

    case 'SET_HIRING_DATA':
      return { ...state, hiringDataIds: action.hiringDataIds, hiringDataById: action.hiringDataById, hiringData: action.hiringData }

    case 'SET_WAGE_PREMIUMS':
      return { ...state, wagePremiumsById: action.wagePremiumsById, wagePremiumsIds: action.wagePremiumsIds, wagePremiums: action.wagePremiums }

    case 'SET_PERMISSIONS':
      return { ...state, permissionsById: action.permissionsById, permissionsIds: action.permissionsIds, permissions: action.permissions }

    case 'SET_PUNCH_RULES':
      return { ...state, punchRulesById: action.punchRulesById, punchRulesIds: action.punchRulesIds, punchRules: action.punchRules }

    case 'SET_PROJECTS':
      return { ...state, projectsById: action.projectsById, projectsIds: action.projectsIds, projects: action.projects }

    case 'SET_PROJECT_OWNERS':
      return { ...state, projectOwnersById: action.projectOwnersById, projectOwnersIds: action.projectOwnersIds, projectOwners: action.projectOwners }

    case 'SET_REQUESTS_FIELDS':
      return {
        ...state,
        requestStatus: action.requestStatus,
        requestStatusById: action.requestStatusById,
        vacationTypesById: action.vacationTypesById,
        attendanceTypes: action.attendanceTypes,
        attendanceTypesById: action.attendanceTypesById,
        attendanceReasonsById: action.attendanceReasonsById,
        attendanceReasons: action.attendanceReasons,
        timeOffTypes: action.timeOffTypes,
        timeOffTypesById: action.timeOffTypesById
      }

    case 'SET_SCHEDULE_TYPES':
      return {
        ...state,
        scheduleTypesById: action.scheduleTypesById,
        scheduleTypesIds: action.scheduleTypesIds,
        scheduleTypes: action.scheduleTypes,
        nonFilterScheduleTypes: action.scheduleTypes.filter(({ searchRange }) => typeof searchRange === 'undefined')
      }

    case 'SET_SCHEDULE_TEMPLATES':
      return {
        ...state,
        scheduleTemplatesById: action.scheduleTemplatesById,
        scheduleTemplatesIds: action.scheduleTemplatesIds,
        scheduleTemplates: action.scheduleTemplates
      }

    case 'SET_STRUCTURES':
      return { ...state, positionsIds: action.positionsIds, positionsById: action.positionsById, positions: action.positions }

    case 'SET_TAGS':
      return { ...state, tagsIds: action.tagsIds, tagsById: action.tagsById, tags: action.tags }

    case 'SET_TEAMS':
      return { ...state, teamsById: action.teamsById, teamsIds: action.teamsIds, teams: action.teams }

    case 'SET_HOLIDAYS':
      return { ...state, holidaysIds: action.holidaysIds, holidaysById: action.holidaysById, holidays: action.holidays }

    case 'SET_FILTERS':
      return { ...state, filtersById: action.filtersById, filtersIds: action.filtersIds, filters: action.filters }

    case 'SET_PROCEDURES':
      return { ...state, proceduresById: action.proceduresById, proceduresIds: action.proceduresIds, procedures: action.procedures }

    case 'SET_SORTS':
      return { ...state, sortsById: action.sortsById, sortsIds: action.sortsIds, sorts: action.sorts }

    case 'SET_USERS':
      return {
        ...state,
        usersIds: action.usersIds,
        usersById: action.usersById,
        users: action.users,
        unarchivedUsers: action.users.filter(user => !user.archived)
      }

    case 'SET_USER_TEMPLATES':
      return { ...state, userTemplatesIds: action.userTemplatesIds, userTemplatesById: action.userTemplatesById, userTemplates: action.userTemplates }

    case 'SET_RESOURCES_ALL_LOADED':
      return { ...state, resourcesAllLoaded: true }

    case 'SET_IS_LOADING_RESOURCES':
      return { ...state, isLoadingResources: true, lastRefreshedAt: new Date() }

    case 'SET_IS_REFRESHING_RESOURCES':
      return { ...state, lastRefreshedAt: new Date() }

    case 'REMOVE_IS_LOADING_RESOURCES':
      return { ...state, isLoadingResources: false }

    case 'SET_LOGGED_OUT':
      return { ...initialState }

    case 'SET_STALE_RESOURCES': {
      let staleResources = { ...state.staleResources, ...action.resources.reduce((acc, resource) => ({ ...acc, [resource]: true }), {}) }
      return { ...state, staleResources }
    }
    case 'CLEAR_STALE_RESOURCES':
      return { ...state, staleResources: {} }
    default:
      return state
  }
}

export default resources
